<template>
  <td class="text-center align-middle">
    <!-- PC design -->
    <div class="d-none d-md-block m-0 p-0">
      <a
        :href="schedule.routes.scheduleEdit"
        class="btn fs-small lh-sm w-100 py-1 mb-1"
        :class="schedule.statusClass.buttonClass"
      >
        内容
      </a>
      <button
        v-if="schedule.isShowRentalContract"
        v-on:click="showRentalContractModal(schedule.id)"
        class="js-colorbox-iframe btn fs-small lh-sm w-100 py-1"
        :class="schedule.statusClass.buttonClass"
      >
        契約書
      </button>
    </div>

    <!-- mobile design -->
    <div class="d-flex justify-content-center">
      <div class="d-md-none">
        <a
          :href="schedule.routes.scheduleEdit"
          class="btn fs-small lh-sm w-100 py-1 mb-1 text-nowrap btn-sm"
          :class="schedule.statusClass.buttonClass"
        >
          内容
        </a>
      </div>
      <div class="ms-1 d-md-none">
        <button
          v-if="schedule.isShowRentalContract"
          v-on:click="showRentalContractModal(schedule.id)"
          class="
            js-colorbox-iframe
            btn
            fs-small
            lh-sm
            w-100
            py-1
            text-nowrap
            btn-sm
          "
          :class="schedule.statusClass.buttonClass"
        >
          契約書
        </button>
      </div>
    </div>
  </td>
</template>

<script lang="ts">
/* Import Vue */
import { defineComponent } from "vue";
import { showRentalContractModal } from "../../../../../compositions/rentContract/modal";

export default defineComponent({
  props: {
    schedule: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
  },
  setup(props: { schedule: any }) {
    return {
      /* functions */
      showRentalContractModal,
    };
  },
});
</script>
